import PageHeader from '../../components/PageHeader';
import FilterPanel from '../../components/FilterPanel';
import { useState } from 'react';
import DataTable from '../../components/DataTable';
import { formatDate } from '../../utils/formatters';
import ReportDialog, { STATUS_OPTIONS, SUBJECT_LABELS } from './ReportDialog';
import { Button, Typography, MenuItem, Stack, TextField } from '@mui/material';
const PlaceIssueReportsPage = ({
  reports,
  filters,
  setFilters,
  loadReports,
  onSaveReport,
  loading,
}) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const columns = [
    {
      key: 'reportId',
      label: 'מזהה',
      render: (report) => report.reportId,
    },
    {
      key: 'placeName',
      label: 'מקום',
      render: (report) => report.placeName,
    },
    {
      key: 'subject',
      label: 'נושא',
      render: (report) => SUBJECT_LABELS[report.subject] || report.subject,
    },
    {
      key: 'reporterName',
      label: 'מדווח',
      render: (report) => report.reporterName,
    },
    {
      key: 'phone',
      label: 'טלפון',
      render: (report) => report.phone,
    },
    {
      key: 'status',
      label: 'סטטוס',
      render: (report) => (
        <Typography
          sx={(theme) =>
            String(`pill issue-${report.status.toLowerCase()}`)
              .split(/\s+/)
              .map(
                (name) =>
                  ({
                    pill: {
                      display: 'inline-flex',
                      alignItems: 'center',
                      minHeight: '26px',
                      borderRadius: '999px',
                      padding: '0 11px',
                      fontWeight: '800',
                      fontSize: '12px',
                      background: '#eef2f6',
                      color: '#344054',
                    },
                    'issue-new': {
                      background: '#eef2ff',
                      color: '#3730a3',
                    },
                    'issue-in_progress': {
                      background: '#fff6d6',
                      color: 'var(--warning)',
                    },
                    'issue-resolved': {
                      background: '#dcfae6',
                      color: '#067647',
                    },
                    'issue-filters': {
                      gridTemplateColumns: 'minmax(190px, 1fr) 120px 170px 72px',
                      [theme.breakpoints.down('sm')]: {
                        gridTemplateColumns: '1fr',
                        display: 'flex',
                        width: '100%',
                        minWidth: '0',
                        gap: '8px',
                        margin: '0',
                        padding: '9px',
                        overflowX: 'auto',
                        overscrollBehaviorInline: 'contain',
                        scrollSnapType: 'inline proximity',
                        scrollbarWidth: 'thin',
                        WebkitOverflowScrolling: 'touch',
                      },
                      gap: '8px',
                      padding: '8px',
                      borderRadius: '12px',
                    },
                  })[name],
              )
              .filter(Boolean)
          }
        >
          {STATUS_OPTIONS.find((item) => item.value === report.status)?.label || report.status}
        </Typography>
      ),
    },
    {
      key: 'createdAt',
      label: 'נוצר',
      render: (report) => formatDate(report.createdAt),
    },
  ];
  return (
    <Stack sx={(theme) => ({ gap: '22px', overflow: 'hidden' })}>
      <PageHeader title={<>דיווחים על מקומות</>} meta={<>{reports.total} דיווחים</>}>
        <FilterPanel className="issue-filters">
          <TextField
            placeholder="חיפוש לפי מזהה, מקום, שם או טלפון"
            value={filters.issueSearch}
            onChange={(event) =>
              setFilters({
                ...filters,
                issueSearch: event.target.value,
              })
            }
            fullWidth
          />
          <TextField
            value={filters.issueStatus}
            onChange={(event) =>
              setFilters({
                ...filters,
                issueStatus: event.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="">כל הסטטוסים</MenuItem>
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            value={filters.issueSubject}
            onChange={(event) =>
              setFilters({
                ...filters,
                issueSubject: event.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="">כל הנושאים</MenuItem>
            {Object.entries(SUBJECT_LABELS).map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
          <Button onClick={() => loadReports(1)}>סינון</Button>
        </FilterPanel>
      </PageHeader>

      <DataTable
        columns={columns}
        items={reports.items}
        rowKey={(report) => report.reportId}
        onRowClick={setSelectedReport}
        page={reports.page}
        limit={reports.limit}
        total={reports.total}
        onPageChange={loadReports}
        loading={loading}
      />

      <ReportDialog
        report={selectedReport}
        open={Boolean(selectedReport)}
        onClose={() => setSelectedReport(null)}
        onSave={onSaveReport}
        loading={loading}
      />
    </Stack>
  );
};
export default PlaceIssueReportsPage;
